import React, { useMemo } from 'react';
import { useOrganizationId } from '../../../../../../hooks/api/useOrganization';
import { useEditNote } from '../../../../../../hooks/api/useNotes';
import { OrganizationNoteDestination } from '../../../../../shared/Notes/utils/types';
import { View } from 'react-native';
import NotesEditor from '../../../../../shared/Notes/NotesEditor';

export type AddNoteSideDrawerContentOwnProps = {
    onClose: (force: boolean) => void;
};

export type AddNoteSideDrawerContentProps = AddNoteSideDrawerContentOwnProps;

const AddNoteSideDrawerContent: React.FC<AddNoteSideDrawerContentProps> = ({ onClose }) => {
    const organizationId = useOrganizationId();
    const noteDestination = useMemo<OrganizationNoteDestination>(
        () => ({
            entityType: 'organization',
            organizationId,
        }),
        [organizationId],
    );
    const { noteEditorProps, key } = useEditNote({
        noteDestination,
        onCreationSuccess: () => {
            onClose(false);
        },
    });
    return (
        <View style={{ width: '100%', height: '100%' }}>
            <NotesEditor
                key={key}
                source="resources.notes-tab.add-drawer"
                onCancel={() => onClose(true)}
                noteDestination={noteDestination}
                {...noteEditorProps}
            />
        </View>
    );
};

export default React.memo(AddNoteSideDrawerContent);
